import { render, staticRenderFns } from "./KnowledgeCheck.vue?vue&type=template&id=94de0418&scoped=true&lang=pug"
import script from "./KnowledgeCheck.vue?vue&type=script&lang=ts"
export * from "./KnowledgeCheck.vue?vue&type=script&lang=ts"
import style0 from "./KnowledgeCheck.vue?vue&type=style&index=0&id=94de0418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94de0418",
  null
  
)

export default component.exports